import React from 'react'
import ScrollableDealModule from '@/components/ScrollableDealModule'
import useFetchPackages from '@/hooks/useFetchPackages'
import useGeoPosition from '@/hooks/useGeoPosition'
import DealCarouselLoader from '@/components/DealCarouselLoader'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

interface PackagesCarouselProps {
  heading?: string
  headingMobile?: string
}

function PackagesCarousel({
  heading = "Don't miss these package deals",
  headingMobile = "Don't miss these deals"
}: PackagesCarouselProps) {
  const { longitude, latitude } = useGeoPosition()
  const { deals, didFetchSucceed } = useFetchPackages({ latitude, longitude })

  if (!didFetchSucceed) {
    return null
  }

  return (
    <LayoutComponentWrapper>
      {deals.length > 0 ? (
        <ScrollableDealModule
          content={{
            heading,
            headingMobile,
            dataArray: deals
          }}
          handleNavOnClick={(href: string) => window.open(href)}
        />
      ) : (
        <DealCarouselLoader />
      )}
    </LayoutComponentWrapper>
  )
}

export default PackagesCarousel
